import { memo } from 'react';

import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import {
  DatePickerProps,
  DatePicker as MuiDatePicker,
} from '@mui/x-date-pickers/DatePicker';
import dayjs, { type Dayjs } from 'dayjs';

export type DatePickerHookProps = {
  label?: string;
  testId?: string;
  minDate?: Dayjs | number | null;
  maxDate?: Dayjs | number | null;
  disableFuture?: boolean;
  inputProps?: any;
  textFieldProps?: any;
  onChange?: (date: string | null) => void;
} & DatePickerProps<any>;

export const DatePicker = memo<DatePickerHookProps>(function DatePicker({
  label,
  minDate = null,
  maxDate = null,
  disableFuture = true,
  value,
  onChange,
  defaultValue,
  testId,
  ...props
}: DatePickerHookProps) {
  const minDateDayjs = dayjs.isDayjs(minDate) || dayjs(minDate);
  const maxDateDayjs = dayjs.isDayjs(maxDate) || dayjs(maxDate);

  return (
    <Stack>
      {label && <InputLabel>{label}</InputLabel>}
      <MuiDatePicker
        format="DD/MM/YYYY"
        minDate={minDateDayjs}
        disableFuture={disableFuture}
        disabled={props?.disabled}
        maxDate={maxDateDayjs}
        value={value ? dayjs(value as any) : null}
        onChange={(date: any) => {
          if (!onChange) return;

          onChange(date?.format('YYYY/MM/DD') || null);
        }}
        slotProps={{
          textField: {
            inputProps: { 'data-testid': testId },
            size: 'small',
            InputProps: props?.inputProps,
            sx: {
              minWidth: 150,
              ...props?.sx,
            },
            ...(props as any),
          },
        }}
      />
    </Stack>
  );
});
